import React from "react";
import ReactPlayer from "react-player";
import * as S from "./styles";

export const Slide7: React.FC = () => {
  return (
    <S.Container>
      <S.Content className="left">
        <S.Wrapper>
          <S.Title>
            Peter Gabriel <span>-</span>
            <br /> Sledgehammer
          </S.Title>
          <S.Video>
            <ReactPlayer
              className="react-player"
              width="100%"
              height="100%"
              url="https://www.youtube.com/watch?v=OJWJE0x7T4Q"
            />
          </S.Video>
        </S.Wrapper>
      </S.Content>
      <S.Content className="right">
        <S.ContentWrapper>
          <S.Name>Johnny Araújo</S.Name>
          <S.Profile>
            Diretor de cinema e de videoclipes de Marcelo D2 e Charlie Brown Jr.
          </S.Profile>
          <S.Text>
            “‘Sledgehammer’, do Peter Gabriel, é um marco pra mim. Além da
            música ser ótima, o clipe foi todo feito em stop motion, uma técnica
            de animação muito moderna para a época, porque era filmada frame a
            frame. Ele ficava parado em frente à câmera, em um plano fechado, e
            vários objetos passavam sobre o rosto dele. Era uma técnica muito
            trabalhosa, totalmente artesanal. Se tivesse alguma coisa fora do
            lugar, tinha de filmar todo o clipe de novo. Esse vídeo era tão
            ousado que virou referência inclusive para a publicidade. Na época,
            foi tipo uma obra do Michel Gondry.”
          </S.Text>
        </S.ContentWrapper>
      </S.Content>
    </S.Container>
  );
};
